var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 764,
    height: 603,
    viewBox: "0 0 764 603",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0.999978 100.913L18.4724 104.65M65.2737 123.587L60.6349 148.622M29.7737 185.075L36.5811 202.284M109.216 436.478L116.023 453.687M150.273 394.364L152.894 376.825M350.716 18.1874L353.769 0.897985M426.949 43.148L441.635 59.7102M427.277 108.578L447.482 111.583M695.307 125.338L716.864 117M751.072 136.75L760.977 154.593M386.264 586.616L397.303 600.496M401.764 559.77L403.751 545.328",
    stroke: "#F3B29D",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/confetti.cc4357c40b5c72152cbeb9f90160da25.svg";
export { ForwardRef as ReactComponent };